<template>
    <div>
        <displayScreen v-if="numberOfScreens > 1" :screenHeight="screen1Height" />
        <displayScreen :screenHeight="numberOfScreens > 1 ? screen2Height : null">
            <div class="flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-800" :class="[numberOfScreens > 1 ? null : 'min-h-screen']" :style="[numberOfScreens > 1 ? {'height': `${screen2Height}px`} : null]">
                <div class="w-full sm:max-w-md mt-6 px-6 py-4 bg-gray-100 shadow-md overflow-hidden sm:rounded-lg">
                    <div class="text-center" v-if="!errorTerminalId">
                        <div>
                            {{ $t('Scan with POS to register terminal') }}
                        </div>
                        <div class="flex justify-center">
                            <qrcode v-if="terminalId" class="mt-3 mx-auto" :value="terminalId" :options="{ width: 300 }" dusk="qr-code"></qrcode>
                            <div v-if="!terminalId" class="mt-3">
                                <font-awesome-icon class="text-lg" icon="spinner" pulse /> {{ $t('Initialising') }}
                            </div>
                        </div>
                        <div v-if="terminalId" class="text-sm font-bold mt-4 py-2 border-t-2 border-b-2 break-all">
                            {{terminalId}}
                        </div>
                    </div>
                    <div v-if="errorTerminalId" class="text-center text-lg text-red-600">
                        <font-awesome-icon icon="exclamation-triangle" />
                        <span>
                            {{ $t('Invalid terminalId') }}
                        </span>
                    </div>
                </div>
            </div>
        </displayScreen>
    </div>
</template>

<script>
import CalculateScreens from "../../Shared/mixin/CalculateScreens";
import DisplayScreen from "../../terminal/Components/DisplayScreen.vue";

export default {
    name: 'Registration',
    components: {DisplayScreen},
    mixins: [
        CalculateScreens,
    ],
    data() {
        return {
            polling: null,
            terminalPolling: null,
            terminalId: '',
            errorTerminalId: false,
        }
    },
    created() {
        axios.get('http://localhost:8080/terminal').then((response) => {
            if (response.data.terminalId) {
                this.terminalId = response.data.terminalId;
            }
            else {
                this.errorTerminalId = true;
                this.startTerminalPolling();
            }
        }).catch(() => {
            if (process.env.MIX_APP_ENV === 'production') {
                this.errorTerminalId = true;
                this.startTerminalPolling();
            }
            else {
                this.terminalId = 'hash-1234';
            }
        }).finally(() => {
            if (!this.errorTerminalId) {
                this.goToLobby();
            }
            this.startPolling();
        });
    },
    mounted() {
        this.calculateScreenHeight();
        window.addEventListener('resize', this.calculateScreenHeight);
    },
    methods: {
        goToLobby() {
            this.getDisplayScreenQueryParams();

            const data = this.screensUrlParam && this.screen1UrlParam && this.screen2UrlParam
                ? {screens: this.screensUrlParam, screen_1: this.screen1UrlParam, screen_2: this.screen2UrlParam}
                : {};

            axios.get(this.route('terminal.active', this.terminalId).url()).then((response) => {
                if (response.data.active) {
                    this.$inertia.visit(
                        this.route('terminal.lobby'),
                        {
                            data: data
                        }
                    );
                }
            }).catch(() => {

            });
        },
        startPolling() {
            this.polling = setInterval(() => {
                this.goToLobby();
            },5000);
        },
        startTerminalPolling() {
            this.terminalPolling = setTimeout(() => {
                window.location.reload();
            },20000);
        }
    },
    beforeDestroy() {
        clearInterval(this.polling);
        clearInterval(this.terminalPolling);
    }
}
</script>
